export const validAmount = (amountEntered) => {
  //console.log("Value came in", valueEntered);
  const validAmount = /^-?\d{0,8}?(\.\d{0,2})?$/;
  const validLength = 12;
  return !amountEntered ||
    (amountEntered.match(validAmount) && amountEntered.length <= validLength)
    ? true
    : false;
};
